import React, { FC } from 'react';
import CheckboxListWithSearch from '@minecraft.checkbox-list-with-search';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';

type Props = FilterData;

const Piercings: FC<Props> = ({ name, label }) => {
  const { getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.tattoosAndPiercings);

  return (
    <>
      <Label>{label}</Label>
      <CheckboxListWithSearch withFormik name={name} options={getMatchedSearchOptions(name)} />
    </>
  );
};

export default Piercings;
